import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSubheader,[_vm._v(_vm._s(_vm.$t('labels.system')))])
}
var staticRenderFns = []

export { render, staticRenderFns }